import type { DeviceResourceSoftwareReadV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { ApplicationsList } from '../../models';
import { toIsoStringIfDate } from '../utils/date.utils';

export function mapApplicationsList(response: DeviceResourceSoftwareReadV2Api): ApplicationsList {
  return {
    applications: response.applications.map((softwareInfo) => ({
      installDate: toIsoStringIfDate(softwareInfo.installDate),
      packageId: '',
      packageName: softwareInfo.packageName,
      sizeOnDisc: softwareInfo.sizeOnDisc,
      type: '',
      versionCode: softwareInfo.versionCode,
      version: softwareInfo.version,
    })),
  };
}
